"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.uniqueNodes = void 0;
function uniqueNodes(nodes) {
    const result = new Map();
    nodes.forEach(node => {
        result.set(`${node.__typename}-${node.id}`, node);
    });
    return Array.from(result.values());
}
exports.uniqueNodes = uniqueNodes;
